'use client'

import { cn } from '@scalis/utils'
import { Badge, BadgeType } from '../badge'
import { BadgeSize } from '../badge/badge.types'
import { Body, BodyColor, BodySize, BodyType } from '../typography'
import { SegmentedControlProps, SegmentedControlSize } from './segmented-control.types'

export const SegmentedControl = <T extends string>({
  tabs,
  activeTab,
  onTabChange,
  className,
  size = SegmentedControlSize.medium,
}: SegmentedControlProps<T>) => {
  return (
    <div className={cn('inline-flex gap-[2px] rounded-xl bg-neutral-20 p-1', className)}>
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id

        return (
          <button
            key={tab.id}
            onClick={() => onTabChange?.(tab.id)}
            className={cn('flex flex-1 items-center justify-center gap-2 rounded-lg px-4 py-1 whitespace-nowrap', {
              'bg-neutral-00 shadow-tab-active': isActive,
              'hover:bg-surface-neutral-20': !isActive,
              'py-[2px]': size === SegmentedControlSize.small,
            })}
          >
            <Body
              size={size === SegmentedControlSize.small ? BodySize.small : BodySize.medium}
              type={isActive ? BodyType.emphasys : BodyType.basic}
              color={isActive ? BodyColor.primary : BodyColor.secondary}
            >
              {tab.label}
            </Body>
            {tab.badgeValue && (
              <Badge
                type={BadgeType.brand}
                size={BadgeSize.medium}
                value={tab.badgeValue}
              />
            )}
          </button>
        )
      })}
    </div>
  )
}
